import { FC, ImgHTMLAttributes } from "react";
import clsx from "classnames";
import { useStyles } from "./Badge.style";
import { User } from "../../../models/user";

export type BadgeType =
  | "unranked"
  | "beginner"
  | "intermediate"
  | "advanced"
  | "expert"
  | "master"
  | "champion"
  | "grand-champion";

type BadgeSize =
  | "xs"
  | "s"
  | "m"
  | "l"
  | "xl"
  | "xxl"
  | "xxl-48"
  | "xxxl"
  | "xxxxl"
  | "xxxxxl"
  | "xxxxxxl";

interface IBadge {
  type: BadgeType;
  size?: BadgeSize;
}

const Badge: FC<IBadge & ImgHTMLAttributes<HTMLImageElement>> = ({
  type = "unranked",
  size = "m",
  ...otherProps
}) => {
  const classes = useStyles();

  return (
    <img
      {...otherProps}
      srcSet={User.getIconFromType(type)}
      alt={"badge"}
      className={clsx(classes.root, otherProps.className, size)}
    />
  );
};

export default Badge;
